// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centered-tabs[data-v-bd031eb2]{display:flex;flex-direction:column;align-items:center;text-align:center}.errorAlert[data-v-bd031eb2]{background-color:red;color:#fff}.centered-tabs .md-tabs-navigation[data-v-bd031eb2]{display:flex;justify-content:center;width:100%;margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
